import { postRequest } from '../../../shared/utils';
import { resolveAvRecipients } from './notificationRecipients';
import { CreateDownstreamStatusUpdateNotificationParams } from './downstreamStatusUpdateToAvTypes';

export async function createDownstreamStatusUpdateNotification({
  candidate,
  screenGridId,
  createdBy,
  configSchema,
}: CreateDownstreamStatusUpdateNotificationParams): Promise<void> {
  const userIds = await resolveAvRecipients({
    screenGridId,
    pcnrId: candidate.pcnrId,
    configSchema,
  });

  if (!userIds.length) {
    return;
  }

  const messageParams = {
    id1: String(candidate.rowId),
    pf_lc: candidate.pcnrLabel,
    qp_status: candidate.statuses.qp_status,
    ncp_status: candidate.statuses.ncp_status,
    cmm_status: candidate.statuses.cmm_status,
    qsfa_status: candidate.statuses.qsfa_status,
    status_segments: candidate.statusSegments,
  };

  await postRequest('/api/notification/createNotification', {
    type: 'DOWNSTREAM_STATUS_UPDATE_TO_AV',
    payload: {
      screen: 'NPI_STEERING',
      rowId: candidate.rowId,
      pkey: 'id1',
      schemaName: 'npi',
      tableName: 'sheet1',
      screenGridId,
      messageKey: 'npiSteering.downstream_status_update_to_av_dynamic_message',
      messageParams,
      actionConfig: {
        allowAccept: false,
        allowReject: false,
        allowDelete: true,
      },
    },
    createdBy,
    userIds,
    status: 'UNREAD',
    message: `There are status updates for the part with the NPI ID ${messageParams.id1}. ${messageParams.status_segments}. Profit Center: ${messageParams.pf_lc}`,
  });
}
